import Vue from 'vue';
import { i18n } from '@/plugins/i18n'

Vue.filter('translate', function (value) {
  return i18n.t(value);
});
